<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">{{ rowTitle }}</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/mPackages">باقات الصيانة</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">{{ rowTitle }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />

            <div v-if="!mainLoading && activeSubscriptions > 0" class="alert alert-warning">
              يوجد <strong>{{ activeSubscriptions }}</strong> اشتراك فعال على هذه الباقة ،
              التعديل لن يؤثر على الاشتراكات القائمة لأنها تحتفظ ببياناتها وقت الاشتراك.
            </div>

            <mainLoader v-if="mainLoading" />
            <MaintenancePackagesForm v-if="!mainLoading && checkAccess('maintenance_packages_update')"
              :cardTitle="rowTitle"
              :dataRow="row"
              :issuesList="issuesList"
            />
            <MaintenancePackagesView v-if="!mainLoading && !checkAccess('maintenance_packages_update')"
              :cardTitle="rowTitle"
              :dataRow="row"
            />
          </div>
        </div>
      </div>
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { checkAccess } from '@/helpers/tools';
import MaintenancePackagesForm from './form.vue';
import MaintenancePackagesView from './view.vue';

export default {
  name: 'MaintenancePackagesUpdate',
  components: {
    MaintenancePackagesForm, MaintenancePackagesView
  },
  data(){
    return {
      id: this.$route.params.id,
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rowTitle: 'تعديل: ',
      row: null,
      issuesList: [],
      activeSubscriptions: 0,
    }
  },
  methods: {
    checkAccess,
    getRowData(){
      this.$http.get(`/api/admin/mPackages/retrieve/${this.id}`).then(({data}) => {
        this.row = data.row;
        this.issuesList = data.issuesList ?? [];
        this.activeSubscriptions = data.activeSubscriptions ?? 0;
        this.rowTitle += data.row.title;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.mainLoading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created(){
    this.getRowData();
  }
}
</script>